import React from 'react';
import AcceptTermsStandardPlanModal from './AcceptTermsStandardPlanModal';
import { DocumentId } from 'types/Document';
import { MerchantType } from 'types/Merchant';
import AcceptTermsFreePlanModal from './AcceptTermsFreePlanModal';

export default function AcceptTermsModal({
  screenName,
  merchantType,
  isClickNoThanks,
  isSpecialMerchant,
  hasSubscriptionPlan,
  onClose,
  onAcceptSubmitted,
  onCustomAcceptNoThanks
}: {
  screenName: DocumentId['screen'];
  merchantType?: MerchantType;
  isClickNoThanks: boolean;
  isSpecialMerchant: boolean;
  hasSubscriptionPlan?: boolean;
  onClose: () => void;
  onAcceptSubmitted: () => Promise<void>;
  onCustomAcceptNoThanks?: () => Promise<void>;
}) {
  let merchantTypeText = '';

  if (merchantType === 'Free' || merchantType === 'Free Boulangeries') {
    merchantTypeText = 'FREE';
  } else if (
    merchantType === 'Standard' ||
    merchantType === 'Standard Boulangeries'
  ) {
    merchantTypeText = 'STANDARD';
  }

  return merchantTypeText === 'FREE' ? (
    <AcceptTermsFreePlanModal
      isClickNoThanks={isClickNoThanks}
      isSpecialMerchant={isSpecialMerchant}
      onClose={onClose}
      onAcceptSubmitted={onAcceptSubmitted}
    />
  ) : (
    <AcceptTermsStandardPlanModal
      screenName={screenName}
      isClickNoThanks={isClickNoThanks}
      onClose={onClose}
      onAcceptSubmitted={onAcceptSubmitted}
      onCustomAcceptNoThanks={onCustomAcceptNoThanks}
      hasSubscriptionPlan={hasSubscriptionPlan}
    />
  );
}
